//@flow
import { camelCase, flow, startCase, toLower, upperFirst } from 'lodash';

import { b2cPagesService } from '@clubmed/utils';

import { BE, PLE, PLE_OPTION, PLE_QUICK, PLE_QUICK_OPTION, SEARCH_LABEL_GA_MAP, STATIC_PAGE_TYPES } from './constants';

const { PAGE_TYPES } = b2cPagesService;

export function getPLECategoryGA(isUserQuickLogged: boolean) {
  return isUserQuickLogged ? PLE_QUICK : PLE;
}

export function getPLEPaymentConfirmationSiteSection(isUserQuickLogged: boolean) {
  return isUserQuickLogged ? PLE_QUICK_OPTION : PLE_OPTION;
}

export function getSearchMappedTypeForLabelGA(type?: string) {
  return SEARCH_LABEL_GA_MAP[type || 'none'];
}

type SiteSectionParams = {
  isUserQuickLogged?: boolean,
  pageType: string,
};

export function getSiteSection({ isUserQuickLogged = false, pageType }: SiteSectionParams) {
  switch (pageType) {
    case PAGE_TYPES.DESTINATION_MICE:
      return `M&E_${pascalCase(PAGE_TYPES.DESTINATION)}`;
    case PAGE_TYPES.HOME_MICE:
      return `M&E_${pascalCase(PAGE_TYPES.HOME)}`;
    case PAGE_TYPES.LANDING_MICE:
      return `M&E_${pascalCase(PAGE_TYPES.LANDING)}`;
    case PAGE_TYPES.RESORT_MICE:
      return `M&E_${pascalCase(PAGE_TYPES.RESORT)}`;
    case STATIC_PAGE_TYPES.BE:
      return BE;
    case STATIC_PAGE_TYPES.PLE:
      return getPLECategoryGA(isUserQuickLogged);
    case STATIC_PAGE_TYPES.PLE_PAYMENT_CONFIRMATION:
      return getPLEPaymentConfirmationSiteSection(isUserQuickLogged);
    default:
      return `Shopping_${pascalCase(pageType)}`;
  }
}

export function noCase(string: string) {
  return flow(
    startCase,
    toLower,
  )(string);
}

export function pascalCase(string: string) {
  return flow(
    camelCase,
    upperFirst,
  )(string);
}
